// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-maps {
  margin-top: 5px;
  height: 50px;
  width: 250px;
  position: fixed;
  transform: translateX(-50%);
  left: 46%;
  top: 0;
}

.custom-icon {
  text-align: center;
}

.icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.circle {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 36px;
  height: 36px;
}

.car-icon {
  width: 28px;
  height: 28px;
}

.plate-label {
  margin-top: 3px;
  font-size: 12px;
  color: black;
  background-color: white;
  text-align: center;
  padding: 2px 4px; /* Añade un poco de espacio alrededor del texto */
  border-radius: 3px; /* Bordes redondeados */
}

.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7); /* Fondo semitransparente */
  z-index: 9999;
}

.spinner {
  border: 8px solid #f3f3f3; /* Light grey */
  border-top: 8px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.vehicle-icon-container {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  border: 2px solid #ccc;
  border-radius: 50%;
  padding: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 1000;
}

.vehicles-icon {
  width: 30px;
  height: 30px;
}

.vehicle-menu {
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 80vw; /* Ancho fijo para que se vea como una tabla */
  max-height: 73vh;
  overflow: hidden; /* Cambiado a hidden para evitar el desplazamiento en todo el menú */
  background-color: white;
  border: 2px solid #ccc;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 10px;
}

.search-container {
  position: sticky; /* Fija el contenedor en la parte superior */
  top: 0; /* Posición en la parte superior */
  background-color: white; /* Fondo blanco para el campo de búsqueda */
  z-index: 1; /* Asegura que esté por encima de otros elementos */
}

.search-input {
  width: 270px;
  padding: 8px;
  margin-bottom: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
}

.vehicle-list {
  max-height: calc(450px - 60px); /* Ajusta la altura restante después de restar el espacio del input */
  overflow-y: auto; /* Habilitar desplazamiento vertical solo en la lista de vehículos */
}

.vehicle-item {
  display: grid;
  grid-template-columns: 30px 130px 160px 350px 350px; /* Añade espacio para la casilla de selección */
  align-items: center;
  padding: 5px 0;
  border-bottom: 1px solid #e0e0e0;
  
  cursor: pointer;
}

.vehicle-checkbox {
  justify-self: center;
}

.vehicle-item:last-child {
  border-bottom: none; /* Quita la línea divisoria de la última fila */
}

.vehicle-status {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  justify-self: center; /* Centra el estado en la celda */
}

.vehicle-plate {
  font-weight: bold;
  padding: 2px;
  text-align: center;
}

.vehicle-time,
.vehicle-name,
.vehicle-message {
  padding: 2px;
  text-align: center;
  white-space: nowrap; /* Evita el salto de línea en el texto */
  overflow: hidden;
  text-overflow: ellipsis; /* Muestra "..." si el texto es muy largo */
}

.vehicle-time {
  justify-self: center; /* Centra el tiempo en la celda */
}

.vehicle-message {
  text-align: left; /* Alinea el mensaje a la izquierda */
}

.no-results {
  padding: 8px;
  color: #777;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Maps.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,SAAS;EACT,MAAM;AACR;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB,EAAE,iDAAiD;EACnE,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C,EAAE,2BAA2B;EACvE,aAAa;AACf;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,6BAA6B,EAAE,SAAS;EACxC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;EAC3C,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,eAAe,EAAE,8CAA8C;EAC/D,gBAAgB;EAChB,gBAAgB,EAAE,oEAAoE;EACtF,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB,EAAE,4CAA4C;EAC9D,MAAM,EAAE,kCAAkC;EAC1C,uBAAuB,EAAE,2CAA2C;EACpE,UAAU,EAAE,mDAAmD;AACjE;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B,EAAE,qEAAqE;EACrG,gBAAgB,EAAE,oEAAoE;AACxF;;AAEA;EACE,aAAa;EACb,mDAAmD,EAAE,+CAA+C;EACpG,mBAAmB;EACnB,cAAc;EACd,gCAAgC;;EAEhC,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB,EAAE,+CAA+C;AACtE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB,EAAE,iCAAiC;AACzD;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB,EAAE,wCAAwC;EAC7D,gBAAgB;EAChB,uBAAuB,EAAE,2CAA2C;AACtE;;AAEA;EACE,oBAAoB,EAAE,iCAAiC;AACzD;;AAEA;EACE,gBAAgB,EAAE,qCAAqC;AACzD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".banner-maps {\n  margin-top: 5px;\n  height: 50px;\n  width: 250px;\n  position: fixed;\n  transform: translateX(-50%);\n  left: 46%;\n  top: 0;\n}\n\n.custom-icon {\n  text-align: center;\n}\n\n.icon-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.circle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n}\n\n.car-icon {\n  width: 28px;\n  height: 28px;\n}\n\n.plate-label {\n  margin-top: 3px;\n  font-size: 12px;\n  color: black;\n  background-color: white;\n  text-align: center;\n  padding: 2px 4px; /* Añade un poco de espacio alrededor del texto */\n  border-radius: 3px; /* Bordes redondeados */\n}\n\n.loading-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.7); /* Fondo semitransparente */\n  z-index: 9999;\n}\n\n.spinner {\n  border: 8px solid #f3f3f3; /* Light grey */\n  border-top: 8px solid #3498db; /* Blue */\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.vehicle-icon-container {\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: white;\n  border: 2px solid #ccc;\n  border-radius: 50%;\n  padding: 5px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  z-index: 1000;\n}\n\n.vehicles-icon {\n  width: 30px;\n  height: 30px;\n}\n\n.vehicle-menu {\n  position: fixed;\n  bottom: 50px;\n  left: 50%;\n  transform: translateX(-50%);\n  max-width: 80vw; /* Ancho fijo para que se vea como una tabla */\n  max-height: 73vh;\n  overflow: hidden; /* Cambiado a hidden para evitar el desplazamiento en todo el menú */\n  background-color: white;\n  border: 2px solid #ccc;\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  padding: 10px;\n}\n\n.search-container {\n  position: sticky; /* Fija el contenedor en la parte superior */\n  top: 0; /* Posición en la parte superior */\n  background-color: white; /* Fondo blanco para el campo de búsqueda */\n  z-index: 1; /* Asegura que esté por encima de otros elementos */\n}\n\n.search-input {\n  width: 270px;\n  padding: 8px;\n  margin-bottom: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.vehicle-list {\n  max-height: calc(450px - 60px); /* Ajusta la altura restante después de restar el espacio del input */\n  overflow-y: auto; /* Habilitar desplazamiento vertical solo en la lista de vehículos */\n}\n\n.vehicle-item {\n  display: grid;\n  grid-template-columns: 30px 130px 160px 350px 350px; /* Añade espacio para la casilla de selección */\n  align-items: center;\n  padding: 5px 0;\n  border-bottom: 1px solid #e0e0e0;\n  \n  cursor: pointer;\n}\n\n.vehicle-checkbox {\n  justify-self: center;\n}\n\n.vehicle-item:last-child {\n  border-bottom: none; /* Quita la línea divisoria de la última fila */\n}\n\n.vehicle-status {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  justify-self: center; /* Centra el estado en la celda */\n}\n\n.vehicle-plate {\n  font-weight: bold;\n  padding: 2px;\n  text-align: center;\n}\n\n.vehicle-time,\n.vehicle-name,\n.vehicle-message {\n  padding: 2px;\n  text-align: center;\n  white-space: nowrap; /* Evita el salto de línea en el texto */\n  overflow: hidden;\n  text-overflow: ellipsis; /* Muestra \"...\" si el texto es muy largo */\n}\n\n.vehicle-time {\n  justify-self: center; /* Centra el tiempo en la celda */\n}\n\n.vehicle-message {\n  text-align: left; /* Alinea el mensaje a la izquierda */\n}\n\n.no-results {\n  padding: 8px;\n  color: #777;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
